import firebase from "@firebase/app";
import Vue from "vue";
import Vuex from "vuex";
import { vuexfireMutations, firestoreAction } from "vuexfire";
import { db } from "../../db";
// import { firestore } from "firebase";
// import router from "../router";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    status: null,
    error: null,
    posters: [],
    poster: null,
    lastPoster: null,
    firstPoster: null,
    queryLimit: 3,
    isNextDisabled: false,
    isPreviousDisabled: true,
  },
  getters: {
    status: (state) => state.status,
    user: (state) => state.user,
    error: (state) => state.error,
    poster: (state) => state.poster,
    posters: (state) => state.posters,
    lastPoster: (state) => state.lastPoster,
    firstPoster: (state) => state.firstPoster,
    isNextDisabled: (state) => state.isNextDisabled,
    isPreviousDisabled: (state) => state.isPreviousDisabled,
  },
  mutations: {
    updateUser: (state, paylod) => {
      state.user = paylod;
    },
    setUser: (state, payload) => {
      state.user = payload;
      // state.user = Firebase.auth().currentUser;
    },
    removeUser: (state) => {
      state.user = null;
    },
    setStatus: (state, payload) => {
      state.status = payload;
    },
    setError: (state, payload) => {
      state.error = payload;
    },
    setPoster: (state, payload) => {
      state.poster = payload;
    },
    setPosters: (state, payload) => {
      state.posters = payload;
    },
    setLastPoster: (state, payload) => {
      state.lastPoster = payload;
    },
    setFirstPoster: (state, payload) => {
      state.firstPoster = payload;
    },
    disableNextButton: (state, payload) => {
      state.isNextDisabled = payload;
    },
    disablePreviousButton: (state, payload) => {
      state.isPreviousDisabled = payload;
    },
    ...vuexfireMutations,
  },
  actions: {
    addPoster: firestoreAction(({ bindFirestoreRef, commit }, payload) => {
      console.log(payload);

      db.collection(`posters`)
        .add({
          downloadURL: payload.downloadURL,
          title: payload.title,
          authors: payload.authors,
          affiliations: payload.affiliations,
          tags: payload.tags,
          description: payload.description,
          timestamp: new Date(),
        })
        .then(function(docRef) {
          console.log("Document written with ID: ", docRef.id);
          bindFirestoreRef("poster", docRef);
          commit("setPoster", docRef);
        })
        .catch(function(error) {
          console.error("Error adding document: ", error);
        });
    }),

    getPoster: firestoreAction(({ bindFirestoreRef, commit }, posterId) => {
      let posterRef = db.collection("posters").doc(posterId);
      bindFirestoreRef("poster", posterRef);
      posterRef
        .get()
        .then((doc) => {
          if (!doc.exists) {
            console.log("No such document!");
          } else {
            commit("setPoster", doc.data());
          }
        })
        .catch((err) => {
          console.log("Error getting document", err);
        });
    }),

    bindPosters: firestoreAction(({ bindFirestoreRef, commit, state }) => {
      let first = db
        .collection("posters")
        .orderBy("timestamp", "desc")
        .limit(state.queryLimit);

      first.get().then(async (documentSnapshots) => {
        const firstVisible = documentSnapshots.docs[0];
        const lastVisible = documentSnapshots.docs[state.queryLimit - 1];
        commit("setLastPoster", lastVisible);
        commit("setFirstPoster", firstVisible);
      });

      bindFirestoreRef("posters", first).then((docs) => {
        commit("setPosters", docs);
      });
    }),

    // NEXT~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    nextPosters: firestoreAction(({ bindFirestoreRef, commit, state }) => {
      let oneBeyondNext = db
        .collection("posters")
        .orderBy("timestamp", "desc")
        .startAfter(state.lastPoster)
        .limit(state.queryLimit + 1);

      oneBeyondNext.get().then((documentSnapshots) => {
        if (documentSnapshots.docs.length == state.queryLimit + 1) {
          const firstVisible = documentSnapshots.docs[0];
          const lastVisible =
            documentSnapshots.docs[documentSnapshots.docs.length - 2];

          let next = db
            .collection("posters")
            .orderBy("timestamp", "desc")
            .startAfter(state.lastPoster)
            .limit(state.queryLimit);

          bindFirestoreRef("posters", next).then((docs) => {
            commit("setPosters", docs);
          });

          commit("setFirstPoster", firstVisible);
          commit("setLastPoster", lastVisible);
        } else {
          const firstVisible = documentSnapshots.docs[0];
          const lastVisible =
            documentSnapshots.docs[documentSnapshots.docs.length - 1];

          let next = db
            .collection("posters")
            .orderBy("timestamp", "desc")
            .startAfter(state.lastPoster)
            .limit(state.queryLimit);

          bindFirestoreRef("posters", next).then((docs) => {
            commit("setPosters", docs);
          });

          commit("setFirstPoster", firstVisible);
          commit("setLastPoster", lastVisible);
          commit("disableNextButton", true);
        }
        commit("disablePreviousButton", false);
      });
    }),

    // PREVIOUS~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    previousPosters: firestoreAction(({ bindFirestoreRef, commit, state }) => {
      let oneBeyondPrevious = db
        .collection("posters")
        .orderBy("timestamp")
        .startAfter(state.firstPoster)
        .limit(state.queryLimit + 1);

      oneBeyondPrevious.get().then(async (documentSnapshots) => {
        if (documentSnapshots.docs.length == state.queryLimit + 1) {
          const firstVisible = documentSnapshots.docs[0];
          const lastVisible =
            documentSnapshots.docs[documentSnapshots.docs.length - 2];

          let previous = db
            .collection("posters")
            .orderBy("timestamp")
            .startAfter(state.firstPoster)
            .limit(state.queryLimit);

          bindFirestoreRef("posters", previous).then((docs) => {
            commit("setPosters", docs.reverse());
          });

          commit("setLastPoster", firstVisible);
          commit("setFirstPoster", lastVisible);
          commit("disableNextButton", false);
        } else {
          const firstVisible = documentSnapshots.docs[0];
          const lastVisible =
            documentSnapshots.docs[documentSnapshots.docs.length - 1];

          let previous = db
            .collection("posters")
            .orderBy("timestamp")
            .startAfter(state.firstPoster)
            .limit(state.queryLimit);

          bindFirestoreRef("posters", previous).then((docs) => {
            commit("setPosters", docs.reverse());
          });

          commit("setLastPoster", firstVisible);
          commit("setFirstPoster", lastVisible);
          commit("disablePreviousButton", true);
        }
      });
    }),

    // unbindTodos: firestoreAction(({ unbindFirestoreRef }) => {
    //   unbindFirestoreRef("posters");
    // }),

    signUpAction({ commit }, payload) {
      commit("setStatus", "loading");
      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password)
        .then((response) => {
          return response.user
            .updateProfile({
              displayName: payload.displayName,
              photoURL: payload.photoURL,
            })
            .then(() => {
              // alert("success");
              // response will have user
              // user will have uid will be updated to the state
              commit("setUser", response.user.uid);
              commit("setStatus", "success");
              commit("setError", null);
              // router.push("/");
              // this.emitDialogClosed();
            });
        })
        .catch((error) => {
          commit("setStatus", "failure");
          commit("setError", error.message);
          // TODO remove this alert later
          // alert(error.message);
        });
    },

    signInAction({ commit }, payload) {
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then((response) => {
          console.log(response);
          // alert(`Logged In as ${response.user.email}`);
          commit("setUser", response.user.uid);
          commit("setStatus", "success");
          commit("setError", null);
        })
        .catch((error) => {
          console.log(error);
          commit("setStatus", "failure");
          commit("setError", error.message);
        });
    },

    signOutAction({ commit }) {
      firebase
        .auth()
        .signOut()
        .then(() => {
          // alert(`Logged Out`);
          commit("setUser", null);
          commit("setStatus", "success");
          commit("setError", null);
        })
        .catch((error) => {
          console.log(error);
          commit("setStatus", "failure");
          commit("setError", error.message);
        });
    },
  },
});
